<template>
  <a class="button-close" @click="close" :class="{disabled: noshow === true}">
    <img src="media/global/btn_continue.png"/>
    <div class="button-title">{{this.$store.state.items.buttons.closeButton}}</div>
  </a>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      },
      noshow () {
        if (this.$store.state.scormLMS.location !== 5) {
          return true
        } else return false
      }
    },
    methods: {
      close() {
        this.$store.commit('scormLMS/returnToRoles');
      }
    },
    components: {},
    props: ['items']
  }

</script>

<style scoped>
.button-close {
  position: absolute;
  bottom: 145px;
  right: 250px;
  z-index: 990;
  cursor: pointer;
  user-select: none;
  -webkit-filter: drop-shadow(1.5px 6px 4px #888 );
  filter: drop-shadow(1.5px 6px 4px #888);
}
.button-close.disabled {
  display: none;
  pointer-events: none;
}
.button-title {
  font-family: 'Nunito';
  position: absolute;
  bottom: 4px;
  right: 34px;
  z-index: 999;
  font-size: 13px;
  text-decoration: none;
  color: black;
}

</style>



// WEBPACK FOOTER //
// ButtonClose.vue?34ade876